export default () => ({
  charts: [],
})
